export default __webpack_public_path__ + "agent_bg1_ma0f78d.png";